"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.observeMentions = observeMentions;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function observeMentions() {
  // Select the node that will be observed for mutations
  var mentionList = document.querySelector('.cke_autocomplete_panel:last-child');

  if (!mentionList) {
    return;
  }

  document.getElementsByClassName('.cke_autocomplete_panel'); // Callback function to execute when mutations are observed

  var callback = function callback(mutationsList) {
    var _iterator = _createForOfIteratorHelper(mutationsList),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var mutation = _step.value;

        if (mutation.type === 'attributes' && mutation.attributeName === 'style' && mentionList.classList.contains('cke_autocomplete_opened')) {
          var _mentionList$style$le;

          // @ts-expect-error
          var leftValue = (_mentionList$style$le = mentionList.style.left) === null || _mentionList$style$le === void 0 ? void 0 : _mentionList$style$le.replace('px', '');

          if (leftValue && document.body.clientWidth < 200 + parseInt(leftValue)) {
            // @ts-expect-error
            mentionList.style.left = "".concat(document.body.clientWidth - 200, "px");
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }; // Create an observer instance linked to the callback function


  var observer = new window.MutationObserver(callback); // Start observing the target node for configured mutations

  observer.observe(mentionList, {
    attributes: true
  });
}